/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AutomaticProxyCountry {
    UNITED_STATES = 'UNITED_STATES',
    UNITED_KINGDOM = 'UNITED_KINGDOM',
    AUSTRALIA = 'AUSTRALIA',
    CANADA = 'CANADA',
    MEXICO = 'MEXICO',
    GERMANY = 'GERMANY',
    HUNGARY = 'HUNGARY',
    ITALY = 'ITALY',
    NETHERLANDS = 'NETHERLANDS',
    POLAND = 'POLAND',
    SPAIN = 'SPAIN',
}
